import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';



interface JwtPayload {
  exp: number;
  [key: string]: any; // Add other keys if needed
}





@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor() { }

  getTokenExpiration(token: string): Date | null {
    try {
      const decoded = jwtDecode<JwtPayload>(token);
      if (decoded.exp) {
        const expirationDate = new Date(decoded.exp * 1000); // convert from seconds to milliseconds
        return expirationDate;
      }
      return null;
    } catch (error) {
      console.error('Invalid token:', error);
      return null;
    }
  }

  isTokenExpired(token: string): boolean {
    const expiration = this.getTokenExpiration(token);
    if (!expiration) return true;
    return expiration.getTime() < new Date().getTime();
  }

}
